import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { AppConfigService } from '../config/app-config.service';

@Injectable({ providedIn: 'root' })
export class SeoService {
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);
  private readonly doc = inject(DOCUMENT);
  private readonly appConfig = inject(AppConfigService);

  private initialized = false;

  initialize(): void {
    if (this.initialized) return;

    const config = this.appConfig.config();
    if (!config) return;

    const seo = config.seo;

    this.title.setTitle(seo.title || 'EDGE APP');

    this.meta.updateTag({ name: 'description', content: seo.description });
    this.meta.updateTag({ property: 'og:title', content: seo.title });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:url', content: seo.appUrl });
    this.meta.updateTag({ property: 'og:site_name', content: 'EDGE APP' });

    if (seo.description) {
      this.meta.updateTag({ property: 'og:description', content: seo.description });
    }

    if (seo.googleVerificationToken) {
      this.meta.updateTag({ name: 'google-site-verification', content: seo.googleVerificationToken });
    }

    this.setCanonicalLink(seo.appUrl);

    this.initialized = true;
  }

  private setCanonicalLink(url: string): void {
    if (!url) return;
    let link = this.doc.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
